var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearBinsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.76 24.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.07,24.51a2.41,2.41,0,0,1-1.78-.73A2.42,2.42,0,0,1,1.55,22V2.75H0V1.2H6.22V0h9.33V1.2h6.21V2.75H20.21V22a2.44,2.44,0,0,1-2.51,2.51ZM18.65,2.75H3.11V22a.92.92,0,0,0,1,1H17.7a.92.92,0,0,0,.66-.3.91.91,0,0,0,.29-.66ZM7.47,19.85H9v-14H7.47Zm5.27,0h1.55v-14H12.74ZM3.11,2.75v0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearBinsIcon);
export default __webpack_public_path__ + "static/media/clear-bins-icon.68d142b5bd410c98aa93b4824f87c45f.svg";
export { ForwardRef as ReactComponent };